import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraButton, SpecraInput, SpecraSelect, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraKeyValueRow, SpecraSegmentedControl } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
const FORMAT_OPTIONS = [
    {
        value: 'docx',
        label: 'Word (.docx)'
    },
    {
        value: 'pdf',
        label: 'PDF'
    }
];
/**
 * "Create package" for an RFI with a response document (WRT-16, OD-75): both
 * formats are always offered, preselected from the RFI's preferred format;
 * the version defaults to the current one.
 */ export function RfiPackageDialog({ error, isCreating, onCreate, onOpenChange, open, preferredFormat = 'docx', submissionFormat = '', versions }) {
    const [format, setFormat] = useState(preferredFormat);
    const [versionId, setVersionId] = useState('');
    const [name, setName] = useState('Final package');
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        onOpenChange: onOpenChange,
        open: open,
        size: "md",
        testId: Testids.rfiPackage.responseDialog,
        title: "Create package",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-[var(--space-3)]",
            children: [
                /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    label: "Name",
                    value: /*#__PURE__*/ _jsx(SpecraInput, {
                        "aria-label": "Package name",
                        maxLength: 512,
                        onChange: (e)=>setName(e.target.value),
                        value: name
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-[var(--space-1)]",
                    children: [
                        /*#__PURE__*/ _jsx(SpecraSegmentedControl, {
                            label: "Format",
                            onValueChange: setFormat,
                            options: FORMAT_OPTIONS,
                            testId: Testids.rfiPackage.responseFormat,
                            value: format
                        }),
                        submissionFormat.trim() ? /*#__PURE__*/ _jsx(SpecraText, {
                            size: "meta",
                            tone: "muted",
                            children: `The RFI asks for: “${submissionFormat.trim()}”`
                        }) : null
                    ]
                }),
                /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    label: "Version",
                    value: /*#__PURE__*/ _jsxs(SpecraSelect, {
                        "aria-label": "Response document version",
                        "data-testid": Testids.rfiPackage.responseVersion,
                        onChange: (e)=>setVersionId(e.target.value),
                        value: versionId,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                value: "",
                                children: "Current version"
                            }),
                            versions.map((v)=>/*#__PURE__*/ _jsx("option", {
                                    value: v.id,
                                    children: `v${v.versionNumber}${v.label ? ` · ${v.label}` : ''}`
                                }, v.id))
                        ]
                    })
                }),
                error ? /*#__PURE__*/ _jsx(SpecraText, {
                    role: "alert",
                    size: "body-ui",
                    tone: "danger",
                    children: error
                }) : null,
                /*#__PURE__*/ _jsx(SpecraButton, {
                    "data-testid": Testids.rfiPackage.responseCreate,
                    disabled: !name.trim(),
                    isLoading: isCreating,
                    onClick: ()=>onCreate({
                            name: name.trim(),
                            format,
                            documentVersionId: versionId
                        }),
                    children: "Create package"
                })
            ]
        })
    });
}
/** "Response document · v{n} · DOCX" (WRT-16 package item label). */ export function responseItemLabel(kind, exportFormat, versionNumber) {
    const fmt = (exportFormat || 'docx').toUpperCase();
    const v = versionNumber ? ` · v${versionNumber}` : '';
    return kind === 'generated_artifact' ? `Generated ${fmt} copy of the response document${v}` : `Response document${v} · ${fmt}`;
}
